// extracted by mini-css-extract-plugin
module.exports = {"information":"property_information__Q73VE","details":"property_details__i1wJa"};